import { createSelector } from 'reselect';

import options from './options';

const { name } = options;

export const curEvents = state => state.models[name].data.items;
